<template>
  <a-modal
    :title="modalTitle"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="edit-body">
      <a-form-model
        :model="form"
        ref="ruleForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 15 }"
        :rules="rules"
      >
        <div class="edit-body-top">
          <div class="edit-body-top-left">
            <a-form-model-item
              :label="$t('page_system_coding_rules')"
              :style="{ display: shows ? 'block' : 'none' }"
            >
              <a-select
                show-search
                optionFilterProp="children"
                @change="handleTypeChanged"
                :placeholder="$t('please_select') + $t('page_system_coding_rules')"
                style="width:100%"
                :allowClear="true"
                v-model="form.codeRuleId"
              >
                <a-select-option
                  v-for="(type, index) in ruleCodeList"
                  :key="index"
                  :value="type.id"
                  >{{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item
              :label="$t('page_business_device_type') + ':'"
              :style="{ marginTop: type === 'add' ? '32px' : '0px' }"
              prop="deviceTypeId"
            >
              <a-select
                show-search
                optionFilterProp="children"
                v-model="form.deviceTypeId"
                :placeholder="$t('please_select') + $t('page_business_device_type')"
                @change="handleTypeChange"
                :allowClear="false"
                style="width: 100%"
              >
                <a-select-option
                  v-for="(type, index) in typeList"
                  :key="index"
                  :value="type.value"
                  >{{ type.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_device_user_data') + ':'"
              :style="{ marginTop: type === 'add' ? '0' : '32px' }"
            >
              <a-date-picker
                :placeholder="$t('please_select') + $t('page_device_user_data')"
                v-model="form.serviceDate"
                type="date"
                style="width: 100%"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_device_edit_installation_position') + ':'"
            >
              <a-tree-select
                :placeholder="$t('please_select') + $t('page_device_edit_installation_position')"
                @change="changeDeptId"
                v-model="form.deptId"
                style="width: 100%"
                :tree-data="rootTreeList"
                :show-checked-strategy="SHOW_PARENT"
                search-placeholder="$t('please_select') + $t('page_device_edit_installation_position')"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_platform_maindata_production_calendar') + ':'"
              required
              prop="calendarCode"
            >
              <a-select
                show-search
                optionFilterProp="children"
                v-model="form.calendarCode"
                :placeholder="$t('please_select') + $t('page_platform_maindata_production_calendar')"
                :allowClear="false"
                :disabled="disableTime"
                style="width: 100%"
              >
                <a-select-option
                  v-for="(type, index) in timeList"
                  :key="index"
                  :value="type.value"
                  >{{ type.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              :label="
                $t('page_plan_maintenance_person_in_charge_of_maintenance') +':'"
            >
              <app-select
                class="top-select"
                :placeholder="$t('please_select') + $t('page_plan_maintenance_person_in_charge_of_maintenance')"
                :list="employeeList"
                v-model="employeeId"
                :allowClear="false"
                style="width: 100%"
              />
            </a-form-model-item>
          </div>
          <div class="edit-body-top-right">
            <a-form-model-item
              :label="$t('page_plan_maintenance_equipment_coding') + ':'"
              prop="code"
            >
              <a-input
                v-model="form.code"
                :disabled="disable"
                :placeholder="$t('common_please_input') + $t('page_plan_maintenance_equipment_coding')"
                :maxLength="32"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_card_workstation_name') + ':'"
              prop="name"
              style="margin-top:32px"
            >
              <a-input
                v-model="form.name"
                :placeholder="$t('common_please_input') + $t('page_card_workstation_name')"
                :maxLength="64"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_product_specification_and_model') + ':'"
            >
              <a-input
                v-model="form.standardModel"
                :placeholder="$t('common_please_input') + $t('page_product_specification_and_model')"
                :maxLength="64"
              />
            </a-form-model-item>
            <a-form-model-item
              :label="$t('page_workstation_maintain_station_group') + ':'"
              ref="groupId"
            >
              <a-tree-select
                v-model="form.groupId"
                style="width: 100%"
                :placeholder="$t('please_select') + $t('page_workstation_maintain_station_group')"
                :tree-data="groups"
                @search="onSearch"
                @change="changeName"
                :searchValue="treeSearchValue"
                multiple
                :show-checked-strategy="SHOW_PARENT"
              />
            </a-form-model-item>
          </div>
        </div>
        <div class="edit-body-footer">
          <a-form-model-item
            :label="$t('remark') + ':'"
            :label-col="{ span: 4 }"
            prop="remark"
          >
            <a-textarea
              :rows="4"
              v-model="form.remark"
              :placeholder="$t('common_please_input') + $t('remark')"
              :maxLength="100"
            />
          </a-form-model-item>
          <a-form-model-item
            :label="$t('page_device_picture') + ':'"
            :label-col="{ span: 4 }"
            v-if="closePicture"
          >
            <AppUploadImg v-model="fileList" :defaultList="defaultList" />
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import {
  WorkStationGroupServiceProxy,
  DeviceServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import AppUploadImg from "@/components/AppUploadImg/index.vue";
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { CalendarServiceProxy } from "@/service-proxies/app-v2/time.service-proxies";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { TreeSelect } from "ant-design-vue";
import dayjs from "dayjs";
import moment from "moment";
import { unFlatTreeData, debug } from "@/components/RenderUtils/utils";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { getUserInfo } from "@/utils/auth";
const mtsp = new MasterlinkTenantServiceProxy();

const workStationGroupServiceProxy = new WorkStationGroupServiceProxy();
const authorityDomainServiceProxy = new AuthorityDomainServiceProxy();
const calendarServiceProxy = new CalendarServiceProxy();
const deviceServiceProxy = new DeviceServiceProxy();
const employeeServiceProxy = new EmployeeServiceProxy();
const codeRuleServiceProxy = new CodeRuleServiceProxy();
const SHOW_PARENT = TreeSelect.SHOW_ALL;

const rootTreeList = [
  {
    title: "",
    value: "",
    key: "",
    children: [],
  },
];
export default {
  props: {
    shows: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      // 新增or编辑
      type: String,
      default: "edit",
    },
    record: {
      type: Object,
      default: () => {
        return {};
      },
    },
    typeList: {
      type: Array,
      default: () => [],
    },
    typeId: {
      type: String,
      default: "",
    },
  },
  components: { AppUploadImg },
  data() {
    return {
      groupNames: "",
      workStation: [], //工位组的数组
      ruleCodeList: [
        //编码规则
      ],
      show: true,
      form: {
        code: "",
        deptId: "",
        deptName: "",
        barCode: "",
        serviceDate: "",
        name: "",
        standardModel: "",
        // serviceLife: ""
        codeRuleId: "",
        remark: "",
        groupNames: "",
        serviceDate: "",
        deviceTypeId: "",
        deviceTypeName: "",
        maintainUserName: "",
        calendarCode: "",
      },
      SHOW_PARENT,
      // treeData,

      confirmLoading: false,
      closePicture: true,
      // workStationList: [],
      treeList: [],
      rootTreeList,
      treeMainList: [],
      timeList: [],

      employeeList: [],
      employeeId: "",
      disable: false,
      fileList: [],
      newTypeId: "",
      defaultList: [],
      disableTime: false,
      treeSearchValue: "",
      groups:[]
      // rules: {
      //   code: [
      //     {
      //       required: true,
      //       message: "请输入设备编码",
      //       trigger: "blur",
      //     },
      //   ],
      //   deviceTypeId: [
      //     {
      //       required: true,
      //       message: "请选择设备类型",
      //       trigger: "blur",
      //     },
      //   ],
      //   calendarCode: [
      //     {
      //       required: true,
      //       message: "请选择生产日历",
      //       trigger: "blur",
      //     },
      //   ],
      //   remark: [{ max: 100, message: "最多只能输入100字符", trigger: "blur" }],
      // },
    };
  },
  computed: {
    modalTitle() {
      return this.type === "edit"
        ? this.$t("page_device_edit_edit_device")
        : this.$t("page_device_add_device");
    },
    rules() {
      return {
        code: [
          {
            required: this.show,
            message: this.$t("page_device_edit_please_enter_the_device_code"),
            trigger: "blur",
          },
        ],
        deviceTypeId: [
          {
            required: true,
            message: this.$t("page_device_edit_please_enter_the_device_type"),
            trigger: "blur",
          },
        ],
        calendarCode: [
          {
            required: true,
            message: this.$t(
              "page_device_edit_please_enter_the_device_production_calendar"
            ),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("page_device_edit_please_enter_the_device_name"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  watch: {
    "form.deviceTypeId": {
      handler(val) {
        // console.log("deviceTypeId:", val);
        if (val) {
          this.changeTypeName();
        }
      },
      immediate: true,
    },
    employeeId: {
      handler(val) {
        if (val) {
          this.changeemployeeListName();
        }
      },
      immediate: true,
    },
    visible: {
      handler(val) {
        if (val) {
          this.form = {
            code: "",
            deptId: "",
            deptName: "",
            barCode: "",
            serviceDate: "",
            name: "",
            standardModel: "",
            // serviceLife: ""
            codeRuleId: "",
            remark: "",
            groupNames: "",
            // serviceDate: "",
            deviceTypeId: "",
            deviceTypeName: "",
            maintainUserName: "",
            calendarCode: "",
          };
          this.treeSearchValue = "";
          this.changeTypeName();
          this.changeemployeeListName();
          this.defaultList = [];
          this.disableTime = false;
          if (this.type === "edit") {
            this.form = this.record;
            this.employeeId = this.record.maintainUserId;
            // this.calendarCode = this.record.calendarCode;
            this.form.serviceDate = this.record.serviceDate
              ? moment(this.record.serviceDate, "YYYY-MM-DD")
              : null;
            this.disable = true;
            this.closePicture = false;
            if (this.form.calendarCode) {
              this.disableTime = true;
            }
            // console.log("11111111",this.form);
          } else {
            this.employeeId = "";
            this.calendarCode = "";
            this.disable = false;
            this.closePicture = true;
            Object.assign(this.form, { deviceTypeId: this.typeId });
            // this.form.deviceTypeId = this.typeId;
            // console.log("bbbbbbbbb:", this.form.deviceTypeId);
          }
        }
      },
      immediate: true,
    },
    fileList: {
      handler(val) {
        if (val) {
          let temp = val.map((item) => ({
            contentType: item.contentType,
            fileName: item.originalFilename || item.filename,
            objectKey: item.objectKey,
          }));

          this.form.recordFileList = [...temp];
        }
      },
      deep: true,
    },
    treeSearchValue(val) {
      // console.log('treeSearchValue:', val)
    },
  },
  created() {
    this.list();
    this.getEnableTreeList();
    this.getPageCalendar();
    this.getEmployeeList();
    // this.changeTypeName();
    // this.getRule();
    codeRuleServiceProxy.list("DeviceObject").then((res) => {
      this.ruleCodeList = res;
    });
  },
  methods: {
    changeTypeName() {
      // console.log(this.typeList);
      this.form.deviceTypeName = "";
      if (this.form.deviceTypeId) {
        let listType = this.typeList.find(
          (item) => item.value === this.form.deviceTypeId
        );
        Object.assign(this.form, { deviceTypeName: listType.label });
      }
    },
    handleTypeChanged(value) {
      if (value) {
        this.form.codeRuleId = value;
        this.form.code = "";
        this.disable = true;
        this.show = false;
        this.$refs.ruleForm.clearValidate("code");
      } else {
        this.disable = false;
        this.show = true;
      }
    },
    handleTypeChange(val) {
      this.form = Object.assign({}, this.form, { deviceTypeId: val });
      this.changeTypeName();
    },
    // handleChange(val){
    //   this.form = Object.assign({}, this.form, { calendarCode: val });
    // },
    changeemployeeListName() {
      if (this.employeeId) {
        let listTime = this.employeeList.find(
          (items) => items.value === this.employeeId
        );
        if (listTime && listTime.hasOwnProperty("label")) {
          this.form.maintainUserName = listTime.label;
        }
      }
    },
    handleOk(e) {
      this.confirmLoading = true;
      if (this.type === "edit") {
        // this.$emit("close", true);
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.updateDevice();
            this.confirmLoading = false;
            // this.form.codeRuleId = "";
          } else {
            // console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.saveDevice();
            this.confirmLoading = false;
            // this.form.codeRuleId = "";
          } else {
            // console.log("error submit!!");
            return false;
          }
        });

        // this.$emit("close", true);
      }
      this.confirmLoading = false;
    },
    handleCancel(e) {
      this.$refs.ruleForm.resetFields();
      this.$emit("close");
      this.form.codeRuleId = "";
      this.show=true
    },
    async list() {
      let result = await workStationGroupServiceProxy.list();
      const data = result.workStationGroupDTOList
      const treeData = unFlatTreeData()(data, (item) => ({
      label: item.name,
      value: item.id,
    }));
    const qr = await mtsp.queryRole(getUserInfo().tenant_id);
    this.groups = [
      {
        label: qr.data.tenantName,
        value: "0",
        children: treeData,
      },
    ]
      // this.workStationList = result.workStationGroupDTOList.map((item) => {
      //   return { title: item.name, key: item.id, value: item.id };
      // });
      // console.log(11111,this.workStationList)
    },
    async getEnableTreeList() {
      let result = await authorityDomainServiceProxy.getEnableTreeList();
      this.treeMainList = result.data.map((item) => {
        return { title: item.title, value: item.id };
      });
      if (result && result.data.length) {
        this.rootTreeList[0].children = this.handleTreeData(
          result.data[0].children
        );
      }

      this.rootTreeList[0].title = this.treeMainList[0].title;
      this.rootTreeList[0].value = this.treeMainList[0].value;
      this.rootTreeList[0].key = this.treeMainList[0].value;
      this.treeList = this.rootTreeList;
      // console.log("d", this.rootTreeList[0].children.value);
    },
    handleTreeData(result) {
      result.map((item) => {
        item = Object.assign(item, {
          title: item.title,
          key: item.id,
          value: item.id,
        });
        if (item.children.length) {
          this.handleTreeData(item.children);
        }
      });
      return result;
    },
    async getPageCalendar() {
      let object = { statusList: [1] };
      let result = await calendarServiceProxy.getPageCalendar(object, 1, -1);
      this.timeList = result.records.map((item) => {
        return { label: item.code + "-" + item.name, value: item.code };
      });
      // console.log("time:", this.timeList);
    },
    async getEmployeeList() {
      const data = await employeeServiceProxy.getEmployeeList({
        statusList: [1],
      });
      this.employeeList = data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    changeDeptId(val) {
      this.parseValue(rootTreeList, val);
    },

    parseValue(arr, value) {
      for (let a = 0; a < arr.length; a++) {
        if (arr[a].value === value) {
          this.form.deptName = arr[a].title;
          return;
        } else if (arr[a].children.length > 0) {
          this.parseValue(arr[a].children, value);
        }
      }
    },
    async saveDevice() {
      let params = {
        barCode: "",
        // calendarCode: this.timeList[0].label,
        // deviceTypeId: this.newTypeId,
        fileDTOList: this.form.recordFileList,
        maintainUserId: this.employeeId,
        waitingUpdateCalendar: "",
      };
      if (this.form.serviceDate) {
        this.form.serviceDate = dayjs(this.form.serviceDate).format(
          "YYYY-MM-DD"
        );
      }
      const paramsNew = Object.assign(params, this.form);

      let result = await deviceServiceProxy.saveDevice(paramsNew);
      if (result) {
        this.$emit("close", true);
      }
    },
    async updateDevice() {
      let params = {
        // deviceTypeId: this.newTypeId,
        maintainUserId: this.employeeId,
      };
      if (this.form.serviceDate) {
        this.form.serviceDate = dayjs(this.form.serviceDate).format(
          "YYYY-MM-DD"
        );
      } else {
        this.form.serviceDate = null;
      }
      Object.assign(params, this.form);
      let result = await deviceServiceProxy.updateDevice(params);
      if (result) {
        this.$emit("close", true);
      }
    },
    onSearch(val) {
      this.treeSearchValue = val;
    },
    changeName(value, label, extra) {
      this.workStation = label;
      this.form.groupNames = this.workStation.toString();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 900px !important;
}
.edit-body {
  .edit-body-top {
    display: flex;
    .edit-body-top-left {
      width: 50%;
    }
    .edit-body-top-right {
      width: 50%;
    }
  }
  .edit-body-footer {
    width: 100%;
  }
}
</style>
